/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-explicit-any */

import IconMinus from '@assets/icons/minus.svg?react';
import {
 SortableContext,
 verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { Box, IconButton, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DraggableField } from './DraggableField';
import { TransformedStructure } from './fieldsModalTypes';

interface FieldsModalCurrentProps {
 selectedFields: TransformedStructure[];
 removeSelectedField: (id: string) => void;
 removeAllSelectedFields: () => void;
}

const FieldsModalCurrent = (props: FieldsModalCurrentProps) => {
 const { selectedFields, removeSelectedField, removeAllSelectedFields } = props;
 const { t } = useTranslation();

 return (
  <Box
   sx={{
    borderRadius: '4px',
    border: (theme: Theme) => `1px solid ${theme.palette.kemek.lightestGray}`,
    // width: 280,
    flex: 1,
    mr: 1,
    overflowY: 'auto',
   }}
  >
   <Box
    sx={{
     p: 1,
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'space-between',
     borderBottom: (theme: Theme) =>
      `1px solid ${theme.palette.kemek.lightestGray}`,
     '.MuiButtonBase-root.MuiCheckbox-root': { p: '6px' },
    }}
   >
    <span>{t('colModal.colsSelected')}</span>
    <IconButton onClick={removeAllSelectedFields}>
     <IconMinus style={{ width: 24, height: 24 }} />
    </IconButton>
   </Box>
   <Box sx={{ p: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
    <SortableContext
     items={selectedFields.map((field) => field?.Key)}
     strategy={verticalListSortingStrategy}
    >
     {selectedFields.map((field) => (
      <DraggableField
       key={field.Key}
       item={field}
       highlight={field.Translation}
       depth={0}
       removeSelectedField={removeSelectedField}
      />
     ))}
    </SortableContext>
    {selectedFields.length === 0 && (
     <Typography color="text.secondary" sx={{ fontStyle: 'italic' }}>
      Drag fields here to select them
     </Typography>
    )}
   </Box>
  </Box>
 );
};

export default FieldsModalCurrent;
